import * as actionTypes from '../actions/actionTypes';

const initialState = {
    user: null,
    error: false,
    loading: false,
    new_token: null,
    register_step: '1'
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_USER:
            return {
                ...state,
                user: action.user,
                error: false,
                loading: false
            };
        case actionTypes.SET_USER_INFO_UPDATE_TOKEN:
            return {
                ...state,
                error: false,
                loading: false,
                new_token: action.new_token,
                register_step: "2"
            };
        case actionTypes.FETCH_USER_FAILED:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        case actionTypes.FETCH_USER_STARTING:
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
};

export default reducer;